import { breadcrumbList } from "./breadcrumbSchema";
import { faqPageSchema } from "./faqSchema";
import { publishedFaqs, relatedMachines } from "../data/equipmentDetail";

const SITE = "https://www.mag-automate.com";

function property(name, value, unitText) {
  if (value === null || value === undefined || value === "") return null;
  return {
    "@type": "PropertyValue",
    name,
    value,
    unitText,
  };
}

export function productAdditionalProperties(robot) {
  const footprint = robot.footprintMm || {};
  const battery = robot.battery || {};
  return [
    property("Payload", robot.payloadKg, "KGM"),
    property("Lift height", robot.liftHeightMm, "MMT"),
    ...(robot.liftHeightOptionsMm || []).map((value) => property("Lift height option", value, "MMT")),
    property("Length", footprint.l, "MMT"),
    property("Width", footprint.w, "MMT"),
    property("Height", footprint.h, "MMT"),
    property("Weight", robot.weightKg, "KGM"),
    property("Top speed", robot.maxSpeedMs, "MTS"),
    property("Turning radius", robot.turningRadiusMm, "MMT"),
    property("Rotation diameter", robot.rotationDiameterMm, "MMT"),
    property("Minimum aisle", robot.minAisleMm, "MMT"),
    property("Ground clearance", robot.groundClearanceMm, "MMT"),
    property("Positioning accuracy", robot.positioningAccuracyMm, "MMT"),
    property("Runtime", battery.runtimeHours, "HUR"),
  ].filter(Boolean);
}

function productSchema(robot, related) {
  return {
    "@context": "https://schema.org",
    "@type": "Product",
    name: robot.displayName,
    description: robot.summary,
    image: `${SITE}${robot.image.src}`,
    brand: { "@type": "Organization", name: robot.vendor },
    manufacturer: { "@type": "Organization", name: robot.vendor },
    category: robot.typeLabel,
    isRelatedTo: related.map((item) => ({
      "@type": "Product",
      name: item.displayName,
      url: `${SITE}/catalog/${item.slug}`,
    })),
    additionalProperty: productAdditionalProperties(robot),
  };
}

export function equipmentDetailJsonLd(robot, robots) {
  const related = relatedMachines(robot, robots);
  const blocks = [
    breadcrumbList([
      { name: "Home", path: "/" },
      { name: "Catalog", path: "/catalog" },
      { name: robot.displayName, path: `/catalog/${robot.slug}` },
    ]),
    productSchema(robot, related),
  ];
  const faqs = publishedFaqs(robot);
  if (faqs.length) blocks.push(faqPageSchema(faqs));
  return blocks;
}

export function catalogIndexJsonLd(robots) {
  return [
    breadcrumbList([
      { name: "Home", path: "/" },
      { name: "Catalog", path: "/catalog" },
    ]),
    {
      "@context": "https://schema.org",
      "@type": "ItemList",
      itemListElement: robots.map((robot, index) => ({
        "@type": "ListItem",
        position: index + 1,
        name: robot.displayName,
        url: `${SITE}/catalog/${robot.slug}`,
      })),
    },
  ];
}
